module.exports = __webpack_public_path__ + "img/Structures-Inspect-Portrait.10d2ba94.png";